import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { Category, CategoryService } from "../../categories/shared";
import { Product, ProductFilterPipe } from "../shared";
import { SlugPipe } from "@atenea-cms";

@Component({
  selector: "product-filter-bar",
  templateUrl: "./product-filter-bar.component.html",
  styleUrls: ["./product-filter-bar.component.scss"],
  providers: [CategoryService, ProductFilterPipe, SlugPipe],
})
export class ProductFilterBarComponent implements OnInit {
  @Input() items: Array<Product> = [];
  @Input() itemsFiltered: Array<Product> = [];
  @Input() reorder: boolean = false;
  @Output() itemsFilteredChange: EventEmitter<any> = new EventEmitter();
  @Output() reorderChange: EventEmitter<any> = new EventEmitter();

  private categories: Category[];
  private name: string = "";
  private sku: string = "";
  private active: boolean = true;
  private category: Category = null;
  private _items: Array<Product> = [];

  constructor(
    private categoryService: CategoryService,
    private productFilterPipe: ProductFilterPipe,
    private slugPipe: SlugPipe
  ) {}

  ngOnInit() {
    this.loadFilters();
    this.categoryService.getAll().subscribe((categories) => {
      this.categories = categories;
      this.filterItems();
      if (this.reorder) {
        this.changeMode();
      }
    });
  }

  changeMode() {
    this.name = null;
    this.sku = null;
    this.active = this.reorder === false ? true : null;

    if (this.reorder === false) {
      this.category = null;
    } else {
      this.category = this.categories.length === 0 ? null : this.categories[0];
    }

    this.filterItems();
    this.reorderChange.emit(this.reorder);
  }

  private filterItems() {
    this.itemsFiltered = this.productFilterPipe.transform(
      this.items,
      this.name,
      this.sku,
      this.active,
      this.category
    );

    this.itemsFiltered.sort(
      (a: Product, b: Product) => a.position - b.position
    );
    this.itemsFilteredChange.emit(this.itemsFiltered);

    this.saveFilters();
  }

  loadFilters() {
    const filters: any = JSON.parse(localStorage.getItem("productListFilters"));

    if (filters && Object.keys(filters).length) {
      const { name, sku, active, category, reorder } = filters;
      this.name = name;
      this.sku = sku;
      this.active = active;
      this.category = category;
      this.reorder = reorder;
    } else {
      this.active = true;
    }
  }

  saveFilters() {
    const data: any = {
      name: this.name,
      sku: this.sku,
      active: this.active,
      category: this.category,
      reorder: this.reorder,
    };

    localStorage.setItem("productListFilters", JSON.stringify(data));
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-filter-bar/product-filter-bar.component.ts